export default function termsController($scope, siteService, Scroll) {
    siteService.getTerms().then(function (terms) {
        $scope.terms = terms;

        Scroll.to("terms", siteService.headerHeight + 15);
    });
}
